export class HttpError extends Error {
  constructor(public status: number, public message: string, public errors?: {path: string[], message: string}[]) {
    super();
  }
}

export class NetworkError extends Error {}
